/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const UnitMeasurementDto = {
    Gram: 'GRAM',
    Milliliter: 'MILLILITER',
    Unit: 'UNIT',
    Person: 'PERSON',
    Hour: 'HOUR',
    Day: 'DAY',
    Meter: 'METER',
    Package: 'PACKAGE',
    People: 'PEOPLE',
} as const;

export type UnitMeasurementDto = typeof UnitMeasurementDto[keyof typeof UnitMeasurementDto];



